import React from 'react';

const RowUser = ({ userId, firstName, username, role, poll, dataReg, isBlocked, dataBlock, courseNumber }) => {
    const userRole = role === 'user' ? 'Пользователь' : 'Админ';
    const dataBlockTime = dataBlock != null ? new Date(dataBlock).toLocaleString() : '---';
    const pollAnswer = poll === 'other_course' ? 'Прохожу другой курс' : 
                      poll === 'superhuman' ? 'Прохожу Superhuman' : 'Не прохожу курсов';
    const isBlock = isBlocked === true ? 'Блокировка' : 'Активен';
    const rowClass = isBlocked ? 'blocked-row' : '';
    const displayUsername = username === "no_username" 
        ? "Никнейм отсутствует" 
        : `@${username}`;

    return (
        <tr className={`user-row ${rowClass}`}>
            <td>{courseNumber}</td>
            <td>{userId}</td>
            <td>{firstName}</td>
            <td>{displayUsername}</td>
            <td>
                <span className={`role-badge ${role}`}>
                    {userRole}
                </span>
            </td>
            <td>{pollAnswer}</td>
            <td>{dataReg}</td>
            <td>
                <span className={`status-badge ${isBlocked ? 'blocked' : 'active'}`}>
                    {isBlock}
                </span>
            </td>
            <td>{dataBlockTime}</td>

            <style>{`
                .user-row {
                    transition: background-color 0.2s;
                }
                
                .user-row:hover {
                    background-color: #f8f9fa;
                }
                
                .blocked-row {
                    background-color: #fff3f3;
                }
                
                .user-row td {
                    padding: 12px 15px;
                    border-bottom: 1px solid #dee2e6;
                }
                
                .role-badge {
                    display: inline-block;
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 12px;
                    font-weight: 500;
                }
                
                .role-badge.user {
                    background-color: #e2f0fd;
                    color: #1a73e8;
                }
                
                .role-badge.admin {
                    background-color: #e6f7ee;
                    color: #0d8041;
                }
                
                .status-badge {
                    display: inline-block;
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 12px;
                    font-weight: 500;
                }
                
                .status-badge.active {
                    background-color: #e6f7ee;
                    color: #0d8041;
                }
                
                .status-badge.blocked {
                    background-color: #fde8e8;
                    color: #d32f2f;
                }
            `}</style> 
        </tr>
    );
};

export default RowUser;